// Anonymous, persistent visitor id (no personal data) so the Admin can count unique visitors.
export const visitorId = () => {
  let v = localStorage.getItem("mc_vid");
  if (!v) { v = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`).slice(0, 36); localStorage.setItem("mc_vid", v); }
  return v;
};
